export const ErrorPageReasons = {
    SsoInit: 'ssoinit',
    ServiceVersion: 'serviceversion',
    Practice: 'practice',
    CustomMessage: 'custommsg',
    Config: 'config',
};
